import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed the closed caption track',
  name: 'changed_video_closed_caption_track',
  params: [
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
    {
      description: 'The selected closed caption track',
      name: 'track',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
